import { render, staticRenderFns } from "./SrListItemActionText.vue?vue&type=template&id=70983024"
import script from "./SrListItemActionText.vue?vue&type=script&lang=js"
export * from "./SrListItemActionText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports